module.exports = __webpack_public_path__ + "img/80.a0003ba6.webp";